import * as cx from "classnames/bind";
import { Button, ButtonLink, Container, Section, Wistia } from "components";
import { HomeLayout } from "layouts";
import Image from "next/legacy/image";
import Link from "next/link";
import Script from "next/script";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useState } from "react";
import { runQuery } from "queries";
import g from "styles/Gallery.module.scss";
import s from "styles/Home.module.scss";

const Custom404 = ({ cocktails, setShowLoginModal, setLoginModalState }) => {
  const { t } = useTranslation();

  return (
    <>
      <Section id="homeTop" style={{ paddingBottom: "0" }}>
        <Container className="fullWidth">
          <div className={cx(s.homeBanner)}>
            <div
              className={cx("videoDisplayMob", s.videoDisplayMob)}
              style={{ opacity: "0.5" }}
            >
              <Wistia code="3cskugg9re" size="177.71% 0 0 0" />
            </div>
            <div
              className={cx("videoDisplay", s.videoDisplay)}
              style={{ opacity: "0.5" }}
            >
              <Wistia code="h6pw70dvz3" size="56.25% 0 0 0" />
            </div>
            <Container className={cx(s.homeContainer)}>
              <div
                className={cx("textDisplay text-center", s.textDisplay)}
                style={{ width: "100%", left: "0", right: "0" }}
              >
                <h1 className="Blue">{t("404 PAGE NOT FOUND")}</h1>
                <div className="ButtonGroup">
                  <ButtonLink
                    href="/"
                    size="fas"
                    svg="cocktail"
                    className="Primary Blue Rad50 Shadow"
                    title={t("Go to homepage")}
                  >
                    {t("Go to homepage")}
                  </ButtonLink>
                </div>
              </div>
            </Container>
          </div>
        </Container>
      </Section>
    </>
  );
};

Custom404.getLayout = (page) => {
  return <HomeLayout style={{ paddingTop: "0px" }}>{page}</HomeLayout>;
};

export const getStaticProps = async ({ locale }) => {
  const ids = [1, 2, 3];
  return {
    props: {
      ...(await serverSideTranslations(locale)),
      ...(
        await runQuery("cocktails/multiple", {
          filter: `{id: {_in: [${ids.join(",")}]}}`,
        })
      ).props,
    },
  };
};

export default Custom404;
